import React, { Component } from "react";
import { getEffectiveBranchCsv, onBranchScopeChange } from "../../../utils/branchScope";
import EnquiryLinksCreationModal from "./enquiryLinksCreationModal";
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner, Modal } from "react-bootstrap";
import FormReportModal from "./FormreportModal";
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import './_admissionForm.scss';
import * as compose from "lodash.flowright";
import { attachModuleGuard, AccessDeniedModal } from "../../../utils/moduleGuard";

// /enquiry-links → "Enquiry_management" (see MODULE_ROUTES in moduleAccessGuard).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
//
// NOTE: copy-link-to-clipboard is a READ and stays ungated, as does the read-only form
// report modal. Only creating/editing a link and deleting one are gated.
const ENQUIRY_MODULE = ["Enquiry_management"];

const DELETE_URL_LINK = gql`
   mutation($id:Int){
    deleteUrlLink(id:$id)
   }
 `;


class Enquiry_Links extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            branchError: "",
            EnquiryLinksCreationModal: false,
            existingAdmissionFormFields: [],
            copySuccess: {},
            FormReportModal: false,
            noDateError: "",
            loading: 0,
            admissionFormLinkData: [],
            deleteId: "",
            accessDeniedShow: false,
         }

        this.guard = attachModuleGuard(this, ENQUIRY_MODULE);
    }

    // The two entry points into EnquiryLinksCreationModal (create + edit). Gating the
    // openers stops the write; the buttons stay visible and clickable.
    openCreateLink = () => {
        if (!this.guard.requireEdit()) return;
        this.setState({ EnquiryLinksCreationModal: true, existingAdmissionFormFields: [] });
    };

    openEditLink = (item) => {
        if (!this.guard.requireEdit()) return;
        this.setState({ EnquiryLinksCreationModal: true, existingAdmissionFormFields: [item] });
    };

    handleCopyClick = (formUrl) => {
        navigator.clipboard.writeText(formUrl).then(() => {
            this.setState({ copySuccess: { [formUrl]: 'Copied' } });
        });
        setTimeout(() => {
            this.setState({ copySuccess: { [formUrl]: null } });
        }, 1500);
    };

    componentDidMount() {
        this.loadLinks();
        // Branch comes from the header (NavbarOne) — reload when it changes.
        this.offBranchScope = onBranchScopeChange(() => this.loadLinks());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    handleBranchSubmit = (e) => {
        e.preventDefault();
        this.loadLinks();
    }

    loadLinks = async () => {
        this.setState({ loader: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($institute_id: Int!,$branch_id: String!){
                getAdmissionFormLinks(institute_id: $institute_id,branch_id: $branch_id){
                  form_url
                  form_name
                  existing_form_field_id
                  form_field_ids
                  lead_count
                  source_details{
                    source_name
                    source_count
                  }
                }
            }    
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                // The header's branch scope, as the CSV this resolver already expects.
                branch_id: getEffectiveBranchCsv(),
            },
            fetchPolicy: 'network-only'
        })
        if (result.data.getAdmissionFormLinks.length > 0) {
            let data = result.data.getAdmissionFormLinks
            this.setState({
                admissionFormLinkData: data,
                loader: 0
            })
        } else {
            this.setState({ loader: 0, noDateError: "No Data Available" })
        }
    }
 
    handleDelete = async (id) => {
        // Checked BEFORE the confirm prompt: a role without is_delete should be told they
        // lack access, not asked to confirm a delete that can't happen.
        if (!this.guard.requireDelete()) return;

        if (window.confirm("Do you want to delete this URL link ?")) {
         await this.props.deleteUrlLink({
            variables:{
                id:id,
            },
            update: (store, { data }) => {
                console.log("data", data);
                if (data.deleteUrlLink) {
                    this.setState({
                        loader: 1,
                        currentStep: 5,
                        submitted: "Deleted Successfully...",
                        spinnerStatus: ""
                    });
                    window.location.reload(false);
                }
            }
        })
    }
    }

    render() {
         console.log("props", this.state);

        return (
            <>
                <Container>
                    <Row className="mt-2">
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                <h6 className="title text-uppercase mb-0">Enquiry Form Links</h6>
                                <div className='d-flex justify-content-end mr-1'>
                                    <div>
                                        <button className="linkCreation_btn text-uppercase" onClick={this.openCreateLink}>Link Creation</button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col sm={12}>
                            <Form>
                                <Form.Row>
                                    {/* No Branch picker — the header (NavbarOne) scopes these links. */}
                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                        <button className="w-75 enquiry_link_btn text-uppercase" onClick={this.handleBranchSubmit}>
                                            Refresh</button>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>


                    {
                        this.state.admissionFormLinkData.length > 0 ? (
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12}>

                                    <Table className="table table-bordered  border-dark" style={{ cursor: "pointer" }}>
                                        <thead className="text-center" style={{ backgroundColor: "rgb(27,35,61)", color: "#fff" }}>
                                            <tr>
                                                <th scope="col">Sno</th>
                                                <th scope="col">Form Name</th>
                                                <th scope="col">Form Url</th>
                                                <th scope="col">Copy</th>
                                                <th scope="col">Edit</th>
                                                <th scope="col">Report</th>
                                                <th scope="col">Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-center">
                                            {
                                                this.state.admissionFormLinkData.map((item, index) => {
                                                    return (
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{item.form_name}</td>
                                                            <td>
                                                                <p style={{ fontWeight: "normal" }}>
                                                                    <a href={item.form_url} target="_blank" rel="noopener noreferrer">
                                                                        {item.form_url}
                                                                    </a>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                {this.state.copySuccess[item.form_url] && <p className='text-success' style={{ fontSize: "10px" }}>Copied</p>}
                                                                <div className="actions-buttons d-flex justify-content-center align-items-top " onClick={() => this.handleCopyClick(item.form_url)}>
                                                                    <Button variant="link" name="view" className="text-theme">
                                                                        <i className="fas  fa-copy text-dark " />
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.openEditLink(item)}>
                                                                    <Button variant="link" name="view" className="text-theme">
                                                                        <i className="fas fa-edit text-dark" />
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                             <td className="text-center">
                                                                {item.lead_count != null && item.lead_count != "" ? (
                                                                    <div onClick={() => { this.setState({ FormReportModal: true, existingAdmissionFormFields: [item] }) }} className="text-primary" style={{ marginTop: "4px" }}>{item.lead_count}</div>
                                                                ) : (
                                                                    <div style={{ marginTop: "10px" }}>{item.lead_count}</div>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <div className="actions-buttons d-flex justify-content-center align-items-top">
                                                                    <Button variant="link" name="view" className="text-theme"  onClick={() => { this.handleDelete(item.existing_form_field_id) }}>
                                                                        <i className="far fa-trash-alt text-danger"/>
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        ) : (
                            <Row>
                                <Col sm={12}>
                                    <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                                </Col>
                                <Col sm={12}>
                                    {
                                        this.state.noDateError != "" ?
                                            (
                                                <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                            )
                                            :
                                            ("")
                                    }
                                </Col>
                            </Row>
                        )
                    }

                    <EnquiryLinksCreationModal
                        stateData={this.state}
                        show={this.state.EnquiryLinksCreationModal}
                        onHide={() => this.setState({ EnquiryLinksCreationModal: false })}
                        getFormFields={this.props.getFormFields}
                        globals={this.props.globals}
                    />

                    <FormReportModal
                        stateData={this.state}
                        show={this.state.FormReportModal}
                        onHide={() => this.setState({ FormReportModal: false })}
                        getFormFields={this.props.getFormFields}
                    />

                    {/* Shown instead of creating / editing / deleting a link when the
                        grant is missing. One modal serves every intercepted action. */}
                    <AccessDeniedModal
                        show={this.state.accessDeniedShow}
                        onHide={this.guard.hideAccessDenied}
                    />
                </Container>
            </>
        )
    }
}
export default withRouter(withApollo(compose(
    graphql(DELETE_URL_LINK, {
        name: "deleteUrlLink"
    }),
)(Enquiry_Links)));

